import { render, staticRenderFns } from "./PublicFavoriteShareSideBar.vue?vue&type=template&id=74dce0f4&scoped=true&"
import script from "./PublicFavoriteShareSideBar.vue?vue&type=script&lang=js&"
export * from "./PublicFavoriteShareSideBar.vue?vue&type=script&lang=js&"
import style0 from "./PublicFavoriteShareSideBar.vue?vue&type=style&index=0&id=74dce0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dce0f4",
  null
  
)

export default component.exports